import { AdminCargoListPage } from "@/pages/admin-cargo-list";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_requeired/admin/cargos/")({
  component: () => <AdminCargoListPage />,
});
